import React from 'react';
import { Paper, Divider, makeStyles, Grid } from '@material-ui/core';

import Description from 'components/typography/Description';

const useStyles = makeStyles({
  stepSpace: {
    flexGrow: 1,
  },
  directionTextSpace: {
    paddingTop: 24,
    paddingBottom: 8,
  },
  text: {
    whiteSpace: 'pre-wrap',
    lineHeight: 1.5,
  },
});

const DirectionCard = ({
  directionUIModel,
  index,
  renderButtons,
  isDraggingOver = false,
}) => {
  const classes = useStyles();

  return (
    <Paper elevation={isDraggingOver ? 8 : 4} style={{ padding: 16 }}>
      <Grid container alignItems="center" style={{ marginBottom: 4 }}>
        <Grid item className={classes.stepSpace}>
          <Description>
            <b>{`STEP ${index + 1}`}</b>
          </Description>
        </Grid>

        <Grid item>{renderButtons && renderButtons()}</Grid>
      </Grid>
      <div>
        <Divider></Divider>
      </div>
      <div className={classes.directionTextSpace}>
        <Description>
          <span className={classes.text}>{directionUIModel.directionText}</span>
        </Description>
      </div>
    </Paper>
  );
};

export default DirectionCard;
